import { faSparkles } from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/design-system/Button";
import "src/design-system/CopilotButton/CopilotButton.css";

// DO NOT copy this pattern. The data-copilot-border wrapper hack exists solely for CopilotButton's
// gradient border and must not spread across the codebase. If you need a custom-styled button,
// create a proper variant in the Button component instead.
export const CopilotButton: React.FC<{
  onClick: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  dataLoc?: string;
  children: React.ReactNode;
  // Forwarded to the wrapper element so the button works as a `Tooltip asChild` trigger
  ref?: React.Ref<HTMLDivElement>;
}> = ({
  isDisabled,
  onClick,
  isLoading = false,
  dataLoc = "copilot-button",
  children,
  ref,
}) => (
  <div ref={ref} data-copilot-border={isLoading ? "animated" : "static"}>
    <Button
      dataLoc={dataLoc}
      isDisabled={isDisabled}
      iconLeft={faSparkles}
      size="sm"
      variant="secondary"
      onClick={onClick}
    >
      <span className="whitespace-nowrap">{children}</span>
    </Button>
  </div>
);
